import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { StoreState } from '../../../../../reducers';
import { SlideData, ImportingSlideData } from '../../../../../containers/Editor/utils/indesignEditor/editableSliders/getData';
import SliderManager from '../../../../../containers/Editor/EditPanel/SliderManager';
import Slide from '../../../../../containers/Editor/EditPanel/SpreadBackgroundPanel/SliderPanel/Slide';
import { ButtonReset } from './styles';
import { setSpreadBackground, importSlidesToSpreadBackground, updateSpreadBackgroundServiceData } from '../../../../../containers/Editor/actions';
import { BackgroundSliderData } from '../../../../../containers/Editor/reducer';

interface SliderPanelProps {
	spread: number[];
	page: number;
	id: string;
	idInConfigs: string;
	slides: SlideData[];
	importingSlides: ImportingSlideData[];
	deps: string[];
	bgMediaData: BackgroundSliderData;
	isGeneralBgData: boolean;
	hasCustomBgMediaData: boolean;
	dispatch: Dispatch<StoreState>;
}

const SliderPanel = ({
	spread,
	page,
	id,
	idInConfigs,
	slides,
	importingSlides,
	deps,
	bgMediaData,
	isGeneralBgData,
	hasCustomBgMediaData,
	dispatch,
}: SliderPanelProps) => {
	const handleReset = (): void => {
		dispatch(setSpreadBackground(spread, null, isGeneralBgData));
	};

	return (
		<>
			<SliderManager
				page={page}
				id={id}
				idInConfigs={idInConfigs}
				slides={slides}
				importingSlides={importingSlides}
				deps={deps}
				SlideComponent={Slide}
				sliderWidth={1024}
				sliderHeight={768}
				shouldScaleImage={true}
				isBackgroundSlider={true}
				onImportSlides={(page, id, idInConfigs, newSlidesData, isFromDesktop) => dispatch(importSlidesToSpreadBackground(page, newSlidesData, isFromDesktop))}
				onUpdateSliderConfig={(page, id, data, isFirstSlideChanged) => {
					dispatch(setSpreadBackground(spread, {
						...bgMediaData,
						slides: data,
					}, isGeneralBgData, true, isFirstSlideChanged));
				}}
				onUpdateSliderElement={(page, id, data, shouldSave, isFirstSlideChanged) => dispatch(updateSpreadBackgroundServiceData(page, data, shouldSave, isFirstSlideChanged))}
			/>
			{hasCustomBgMediaData &&
				<ButtonReset
					type="button"
					onClick={handleReset}
				>
					<Translate value="messages.reset_to_default" />
				</ButtonReset>
			}
		</>
	);
};

export default SliderPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/SliderPanel/index.tsx